const topics = [
  { name: '恋爱韩漫', heat: '12.8k', color: 'bg-accent-100 text-accent-700' },
  { name: '奇幻韩漫', heat: '10.5k', color: 'bg-accent-100 text-accent-700' },
  { name: '动作韩漫', heat: '9.2k', color: 'bg-secondary-100 text-secondary-700' },
  { name: '悬疑韩漫', heat: '8.6k', color: 'bg-secondary-100 text-secondary-700' },
  { name: '校园韩漫', heat: '7.3k', color: 'bg-secondary-100 text-secondary-700' },
  { name: '下拉式阅读', heat: '6.8k', color: 'bg-secondary-100 text-secondary-700' },
  { name: '韩漫全集', heat: '6.1k', color: 'bg-secondary-100 text-secondary-700' },
  { name: '周更韩漫', heat: '5.4k', color: 'bg-secondary-100 text-secondary-700' },
  { name: '新番韩漫', heat: '4.9k', color: 'bg-secondary-100 text-secondary-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-8 md:mb-10">
          话题标签
        </h2>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <span
              key={i}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium ${topic.color} cursor-pointer hover:opacity-80 transition-opacity whitespace-nowrap`}
            >
              {topic.name}
              <span className="text-[11px] opacity-70">{topic.heat}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}